import { Box, Divider, Typography, useMediaQuery } from "@mui/material";
import BoardCard from "../../components/BoardCard";
//import { useDirection } from "../../UtilityFunctions";

import '../LandingPage/landpage.css';
import { useDirection } from '../../UtilityFunctions';


function OfficersSection(props) {

    //const direction = useDirection();
    const isSmallScreen = useMediaQuery("(max-width:400px)");
    const direction = useDirection();
    /*
    marketing = "Marketing"
        logistics = "Logistics"
        pd = "Professional Development"
        community = "Community Engagement"
        intercultural = "Intercultural"

    */
    const execMembers = [
        {
            names: ["Matthew"],
            linkedIn: ["https://www.linkedin.com/in/matthew-mangosing/"],
            image: "/img_images/Profiles/Matthew_BoardPhoto.jpg",
            position: "Fundraising"
        },
        {
            names: ["Conrad"],
            linkedIn: ["https://www.linkedin.com/in/conrad-mendoza-88137428b/"],
            image: "/img_images/Profiles/Conrad_BoardPhoto.jpg",
            position: "Fundraising"
        },
        {
            names: ["Tyler"],
            linkedIn: ["https://www.linkedin.com/in/tyler-valdez-ab7773278/"],
            image: "/img_images/Profiles/Tyler_BoardPhoto.jpg",
            position: "Marketing"
        },
        {
            names: ["Renee"],
            linkedIn: ["https://www.linkedin.com/in/renee-floreshomepage/"],
            image: "/img_images/Profiles/Renee_BoardPhoto.jpg",
            position: "Marketing"
        },
        {
            names: ["Victoria"],
            linkedIn: ["https://www.linkedin.com/in/victoriahdang/"],
            image: "/img_images/Profiles/Victoria_BoardPhoto.jpg",
            position: "Professional Development"
        },
        {
            names: ["Krishnateja"],
            linkedIn: ["www.linkedin.com/in/krishnateja-reddy"],
            image: "/img_images/Profiles/Krish_BoardPhoto.jpg",
            position: "Professional Development"
        },
        {
            names: ["AJ"],
            linkedIn: ["www.linkedin.com/in/alexandra-young-71a263332"],
            image: "/img_images/Profiles/AJ_BoardPhoto.jpg",
            position: "Intercultural"
        },
        {
            names: ["Jayden"],
            linkedIn: ["www.linkedin.com/in/jayden-diawatan"],
            image: "/img_images/Profiles/Jayden_BoardPhoto.jpg",
            position: "Intercultural"
        },
        {
            names: ["Lauren"],
            linkedIn: ["www.linkedin.com/in/lauren-mariebalatbat"],
            image: "/img_images/Profiles/Lauren_BoardPhoto.jpg",
            position: "Community"
        },
        {
            names: ["Kaitlin"],
            linkedIn: ["https://www.linkedin.com/in/kaitlin-espejo/"],
            image: "/img_images/Profiles/Kaitlin_BoardPhoto.jpg",
            position: "Community"
        },
        {
            names: ["Aidan"],
            linkedIn: ["www.linkedin.com/in/aidanhoang"],
            image: "/img_images/Profiles/Aidan_BoardPhoto.jpg",
            position: "Community"
        },
        {
            names: ["Charlie"],
            linkedIn: ["www.linkedin.com/in/charlie-thompson-856797272"],
            image: "/img_images/Profiles/Charlie_BoardPhoto.jpg",
            position: "Media"
        },
        {
            names: ["Ayana"],
            linkedIn: ["https://www.linkedin.com/in/ayana-fernando?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"],
            image: "/img_images/Profiles/Ayana_BoardPhoto.jpg",
            position: "Logistics"
        },
        {
            names: ["Eli"],
            linkedIn: ["https://www.linkedin.com/in/elijahgabrielmanuel/"],
            image: "/img_images/Profiles/Eli_BoardPhoto.jpg",
            position: "Logistics"
        },
        {
            names: ["Peri"],
            linkedIn: ["https://www.linkedin.com/in/peri-weilacher-90aa61300"],
            image: "/img_images/Profiles/Peri_BoardPhoto.jpg",
            position: "Logistics"
        },
        {
            names: ["Sean"],
            linkedIn: ["https://www.linkedin.com/in/seanfleming09"],
            image: "/img_images/Profiles/Sean_BoardPhoto.jpg",
            position: "Web Development"
        },

        
    ];
    return (
        <div className='entire-page'>
        {direction === "horizontal" ? (
            <Box sx={{ display: "flex", flexDirection: "column", justifyContent: isSmallScreen ?  "start" : "start", alignContent:"center", bgcolor: "transparent"}}>

                <Box sx={{ display: 'flex', flexDirection: "row", justifyContent: 'center', alignItems: "center", bgcolor: "transparent", margin:"20px"}}>
                    <Divider sx={{width: "10%", height: "5px", bgcolor: "#FAF9F6"}}/>
                        <Typography variant="h3"  align='center' color="primary" sx={{margin: "20px"}}>
                            Officers
                        </Typography>
                    <Divider sx={{width: "10%", height: "5px", bgcolor: "#FAF9F6"}}/>
                </Box>
                
                {/* Officer Members Cards */}
                <Box sx={{ display: 'grid', gridTemplateColumns: "repeat(4, 1fr)", justifyItems: 'center', bgcolor: "transparent", gap: "20px"}}>

                {execMembers.map((member, index) => (
                        <BoardCard 
                            key={index}
                            names={member.names}
                            linkedIn={member.linkedIn}
                            image={member.image}
                            position={member.position}
                        />
                    ))}  
                </Box>
            </Box>
        ) : (
            <Box sx={{ display: "flex", flexDirection: "column", justifyContent: isSmallScreen ?  "start" : "start", alignContent:"center", bgcolor: "transparent"}}>

                <Box sx={{ display: 'flex', flexDirection: "row", justifyContent: 'center', alignItems: "center", bgcolor: "transparent", margin:"20px"}}>
                    <Divider sx={{width: "10%", height: "5px", bgcolor: "#FAF9F6"}}/>
                        <Typography variant="h3"  align='center' color="primary" sx={{margin: "20px"}}>
                            Officers
                        </Typography>
                    <Divider sx={{width: "10%", height: "5px", bgcolor: "#FAF9F6"}}/>
                </Box>
                
                {/* Officer Members Cards */}
                <Box sx={{ display: 'grid', gridTemplateColumns: "repeat(2, 1fr)", justifyItems: 'center', bgcolor: "transparent", gap: "20px"}}>

                {execMembers.map((member, index) => (
                        <BoardCard 
                            key={index}
                            names={member.names}
                            linkedIn={member.linkedIn}
                            image={member.image}
                            position={member.position}
                        />
                    ))}  
                </Box>
            </Box>
        )}
        
        </div>
    )
}

export default OfficersSection;